import React from 'react'
import { AppLink } from '@easyllama/ui-components'
import { Card, CardContent, CardHeader, CardTitle } from '~/atoms/shadcn/card'
import { Tooltip, TooltipContent, TooltipTrigger } from '~/atoms/shadcn/tooltip'

const CARD_CLASSNAME = 'py-6 px-4 sm:px-8 border-llama-grey-8 rounded-2xl'
const CARD_TITLE_CLASSNAME = 'text-lg font-bold  text-llama-grey-7 leading-[150%]'

const KioskDocumentsPanel = ({ policies = [], assets = {} }) => (
  <Card className={`w-full md:w-72 flex-shrink-0 gap-0 ${CARD_CLASSNAME} bg-white`}>
    <CardHeader className='p-0'>
      <CardTitle as='h2' className={CARD_TITLE_CLASSNAME}>My Documents</CardTitle>
    </CardHeader>

    <div className='my-6 border-b border-llama-grey-8' />

    <CardContent className='p-0 flex-1 flex flex-col justify-start gap-4'>
      {policies.length === 0 ? (
        <div className='flex flex-col items-center gap-3 text-center'>
          <img src={assets.cloudLargeUrl} alt='' aria-hidden='true' className='h-20' />
          <span className='text-sm text-llama-grey-5'>No documents available yet.</span>
        </div>
      ) : (
        <>
          {policies.length < 2 && (
            <img src={assets.cloudLargeUrl} alt='' aria-hidden='true' className='self-center h-20' />
          )}
          {policies.map(policy => (
            <div key={policy.id} className='flex items-center justify-between gap-2'>
              <AppLink
                href={policy.handbookUrl}
                target='_blank'
                rel='noopener noreferrer'
                text={(
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <div className='min-w-0 truncate'>{policy.name}</div>
                    </TooltipTrigger>
                    <TooltipContent showArrow>
                      {policy.name}
                    </TooltipContent>
                  </Tooltip>
                )}
                size='small'
                icon={<img src={assets.fileIconUrl} className='!size-7' alt='' aria-hidden='true' />}
                className='flex-1 min-w-0'
              />
              <AppLink
                href={policy.handbookUrl}
                target='_blank'
                rel='noopener noreferrer'
                text=''
                size='small'
                aria-label={`Download ${policy.name}`}
                icon={<img src={assets.cloudIconUrl} className='size-4' alt='' aria-hidden='true' />}
              />
            </div>
          ))}
        </>
      )}
    </CardContent>
  </Card>
)

export default KioskDocumentsPanel
